import { render, staticRenderFns } from "./CbsFormDesignerAi.vue?vue&type=template&id=1b29bb35&scoped=true"
import script from "./CbsFormDesignerAi.vue?vue&type=script&lang=js"
export * from "./CbsFormDesignerAi.vue?vue&type=script&lang=js"
import style0 from "./CbsFormDesignerAi.vue?vue&type=style&index=0&id=1b29bb35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b29bb35",
  null
  
)

export default component.exports